<!--  -->
<template>
  <div class="order-container" :class="['order-container',showDetail  ? 'detail-box':'']">
    <div class="order-top">
      <div :class="['order-title',currentTab == 'new' ? 'select-tab':'']" @click="changeTab('new')">
        订单
        <!-- <span>({{orderCount}})</span> -->
      </div>
      <div
        :class="['order-title',currentTab == 'history' ? 'select-tab':'']"
        @click="changeTab('history')"
      >
        历史订单
        <!-- <span>({{historyCount}})</span> -->
      </div>
    </div>

    <template v-if="!showDetail">
      <div class="small_loading" v-if="loading">
        <img src="https://static.getconnectplus.com/tb_webassets/tb_small_loading.gif" />
      </div>

      <template v-else>
        <div class="tips" v-if="showtips&&currentTab=='history'">
          <div>
            <img class="tip-info" src="../assets/image/icon/tip-info.svg" />
          </div>
          <div class="tip-text">Thom Browne官网进行了一次全面的系统升级，9月30日前的订单会在这里显示</div>
          <div class="close" @click="tipclose()">
            <img class="tip-close" src="../assets/image/icon/tip-close.svg" />
          </div>
        </div>
        <!-- <div class="no-data" v-if="orderList.length<=0">您暂未没有订单记录</div> -->
        <div class="order-list" ref="orderlist">
          <template v-if="currentTab == 'new'">
            <div class="order-box" v-for=" (item,index) in orderList" :key="index">
              <div class="order-item">
                <div class="label-c">
                  <div>下单日期</div>
                  <div>{{item.createTime}}</div>
                </div>
              </div>
              <div class="order-item order-no">
                <div class="label-c">
                  <div>订单号</div>
                  <div>{{item.orderNo}}</div>
                </div>
              </div>

              <div class="order-item order-status">
                <div class="label-c">
                  <div>状态</div>
                  <div class="orderstatus" v-if="item.status=='0'">
                    待付款
                    <count-down
                      :time="item.leasttime"
                      :orderId="item.id"
                      :index="index"
                      v-on:bindcallback="bindcallback"
                    ></count-down>
                  </div>
                  <div class="orderstatus" v-if="item.status=='1'">待发货</div>
                  <div class="orderstatus" v-if="item.status=='2'">已发货</div>
                  <div class="orderstatus" v-if="item.status=='22'">部分发货</div>
                  <div class="orderstatus" v-if="item.status=='3'">已完成</div>
                  <div class="orderstatus" v-if="item.status=='4'">已关闭</div>
                  <div class="orderstatus" v-if="item.status=='5'">已退款</div>
                  <div class="orderstatus" v-if="item.status=='6'">已签收</div>
                </div>
              </div>
              <div class="order-item order-action">
                <div class="label-c">
                  <div class="del-tips" v-if="iscancle&&chooseindex == index">
                    <div>您确定吗？</div>
                    <div>
                      <span class="span1" @click="canCelOrder(item.id,index)">是</span>
                      <span class="span2">或</span>
                      <span class="span1" @click="iscancle = false">否</span>
                    </div>
                  </div>
                  <template v-else>
                    <div class="herf_tilte" @click="showOrderDetail(item.id)">查看详情</div>
                    <div class="actions">
                      <div v-if="item.status==0">
                        <span class="herf_tilte" @click="goTocheckout(item)">立即支付</span>

                        <span class="herf_tilte">
                          <span class="herf_tilte" @click="cancle(item.id,index)">取消订单</span>
                        </span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="hello">
              <div class="no-data" v-if="orderList.length==0">您暂未没有订单记录</div>
            </div>
          </template>
          <template v-else>
            <div class="order-box" v-for=" (item,index2) in historyList" :key="index2">
              <div class="order-item">
                <div class="label-c">
                  <div>下单日期</div>
                  <div>{{item.orderDate}}</div>
                </div>
              </div>
              <div class="order-item order-no">
                <div class="label-c">
                  <div>订单号</div>
                  <div>{{item.portalOrderNumber}}</div>
                </div>
              </div>

              <div class="order-item order-status">
                <div class="label-c">
                  <div>状态</div>
                  <div class="orderstatus" v-if="item.orderLineStatus=='Sent'">已完成</div>
                  <div class="orderstatus" v-if="item.orderLineStatus=='Return'">已退款</div>
                  <div class="orderstatus" v-if="item.orderLineStatus=='PartReturn'">部分退款</div>
                </div>
              </div>
              <div class="order-item order-action">
                <div class="label-c">
                  <div
                    class="herf_tilte"
                    @click="showOrderDetail(item.portalOrderNumber,'history')"
                  >查看详情</div>
                </div>
              </div>
            </div>
            <div class="hello">
              <div class="no-data" v-if="historyList.length==0">您的历史订单中暂无数据</div>
            </div>
          </template>

          <!-- <div class="is-loading" v-if="hasMore">加载中...</div>
          <div class="no-more" v-else> -- 我是有底线哒 -- </div>-->
        </div>
      </template>
    </template>
    <!-- <template v-else>
      <order-detail
        :index="currentIndex"
        @cancelOrder="cancelOrder"
        @goPayorderdetail="goPayorderdetail"
        :orderInfo="OrderInfo"
        :showDetail="showDetail"
        v-on:refreshOrder="getInit"
      ></order-detail>
    </template>-->
    <pay-pop
      :paymethod="paymethod"
      :showPay="showPay"
      v-on:close="close"
      @goPay="goPay"
      @payMethod="payMethod"
    ></pay-pop>
    <pay ref="pay" :money="$utils.toThousands(payAmount)" @paysuccess="paysuccess"></pay>
  </div>
</template>

<script>
import OrderDetail from "./common/OrderDetail";
import PayPop from "./common/PayPop";
import Pay from "./common/Pay.vue";
import countDown from "./common/countDown.vue";
import "../assets/style/order.less";
export default {
  data() {
    return {
      orderCount: 0,
      historyCount: 0,
      showtips: true,
      currentTab: "new",
      paidOrderInfo: {},
      showPay: false,
      showDetail: false,
      API: this.$store.state.API,
      currentPage: 1,
      pageSize: 10,
      paymethod: 0, //0代表支付宝1代表微信
      payAmount: 0, //当前待支付订单需要支付的金额
      orderId: "",
      loading2: true,
      loading: true,
      hasMore: false,
      loadShow: false,
      isLoading: false,
      iscancle: false,
      historyList: [],
      orderList: [],
      OrderInfo: null,
      storeSwiperOption: {
        pagination: { el: ".swiper-pagination", clickable: true },
        loop: false,
        autoplay: false,
        //speed是一张图划过的时间长度
        speed: 200,
        on: {
          slideChangeTransitionStart: function() {
            // _this.componentIndex = this.realIndex;
          }
        }
      }
    };
  },
  // watch: {
  //   $route: function(newVal, oldVal) {}
  // },
  components: { OrderDetail, PayPop, Pay, countDown },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.currentTab = this.$route.query.tab
      ? this.$route.query.tab
      : this.currentTab;
    document.title = "订单" + this.$store.state.titleSuffix;
    this.showtips = window.localStorage.getItem("tipclose") ? false : true;
    this.getDataList();
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.paymethod = 1;
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.currentTab = to.query.tab ? to.query.tab : this.currentTab;
    this.getDataList();
    next();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.$gaAction.pageview(document.title, this.$route.path);
    if (this.$route.query.out_trade_no) {
      console.log(this.$route.query);
      this.getOrderId(this.$route.query.out_trade_no);
    }
    if (this.$route.query.weChatPaidId) {
      this.getOrderDetail(this.$route.query.weChatPaidId);
    }
    // this.getInit();
    this.$nextTick(() => {
      // window.addEventListener("scroll", this.scroll, false); // 监听（绑定）滚轮滚动事件
    });
  },
  destroyed() {
    // window.removeEventListener("scroll", this.scroll);
  },
  computed: {
    isClickAcount() {
      return this.$store.state.isClickAcount;
    }
  },
  watch: {
    isClickAcount(curVal, oldVal) {
      this.showDetail = false;
      this.currentPage = 1;
    }
  },
  methods: {
    getCustomerId() {
      // 获得购物车列表
      return new Promise((resolve, reject) => {
        let url =
          this.API.order.getCustomerId +
          "?phone=" +
          this.$store.state.phoneNumber;
        this.$http
          .get(url, {})
          .then(res => {
            if (res.data.message == "success") {
              resolve(res.data.returnData);
            } else {
              resolve(res.data.returnData);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getHistoryOrders(customerId) {
      var that = this;
      let url =
        this.API.order.getHistoryOrderList + "?customerId=" + customerId;
      this.$http.get(url, {}).then(res => {
        if (res.data.message == "success") {
          this.historyList = res.data.returnData;
          this.historyCount = res.data.returnData.length;
        }
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      });
    },
    tipclose() {
      window.localStorage.setItem("tipclose", "1");
      this.showtips = false;
    },
    async getDataList() {
      this.loading = true;
      if (this.currentTab == "new") {
        this.getInit();
      } else {
        let customerId = await this.getCustomerId();
        if (customerId) {
          this.getHistoryOrders(customerId);
        } else {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      }
    },
    async changeTab(tab) {
      this.currentTab = tab;
      this.$router.push("/account/order-list?tab=" + tab);
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    async bindcallback(data) {
      let url = this.API.order.cancelOrder;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      let params = {
        openId: OpenId || this.$store.state.userId,
        orderId: data.id,
        formId: "12"
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.orderList[index].status = 4;
          } else {
            // this.$Message.error(res.data.message);
          }
        })
        .catch(err => []);
    },
    cancle(id, index) {
      this.chooseindex = index;
      this.iscancle = true;
    },
    async canCelOrder(id, index) {
      let url = this.API.order.cancelOrder;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      let params = {
        openId: OpenId || this.$store.state.userId,
        orderId: id,
        formId: "12"
      };

      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.orderList[index].status = 4;
            this.iscancle = false;
            this.$Message.success("取消订单成功");
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => []);
    },
    goOrderList() {
      if (this.showDetail) {
        this.showDetail = false;
      }
    },

    paysuccess() {
      this.isConfirmLeave = true;
      this.getInit();
    },
    payMethod(e) {
      // 获得方式
      this.paymethod = e;
    },

    goPay(e) {
      this.showPay = false;
      let paywayTxt = "ALIPAY";
      if (this.paymethod == 1) {
        paywayTxt = "WECHAT";
      }
      this.gaSetCheckoutOption();
      this.$refs.pay.doPay(this.orderId, paywayTxt);
    },

    //GA set_checkout_option埋点
    gaSetCheckoutOption() {
      let payType = "";
      if (this.paymethod == 0) {
        payType = "Alipay";
      } else {
        payType = "WeChatpay";
      }
      this.$gaAction.set_checkout_option(this.payAmount, payType);
    },

    goPayorderdetail(e) {
      //从详情去付款
      this.showPay = true;
      this.payAmount = e.totalAmount;
      this.orderId = e.id;
      console.log(e, "详情付款");
    },
    goTocheckout(e) {
      console.log(e, "需付款的内容");
      this.showPay = true;
      this.payAmount = e.totalAmount;
      this.orderId = e.id;
    },
    async getInit() {
      this.currentPage = 1;
      let response = await this.getOrderList(this.currentPage);
      // this.initDataCallback(response);
    },
    initDataCallback(data) {
      console.log(data, "这个是啥呢");
      this.orderList = data.list;

      this.hasMore = data.count > this.orderList.length;
      this.currentPage = this.currentPage + 1;
      this.loadShow = false;
    },
    getMoreCallback(data) {
      let orderList = this.orderList;
      orderList = orderList.concat(data.list);
      this.orderList = Object.assign(orderList);
      this.hasMore = data.count > orderList.length;
      this.currentPage = this.currentPage + 1;
      // this.isLoading = false;
    },
    async scroll() {
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 设备/屏幕高度
      let scrollObj = document.querySelector(".order-content"); // 滚动区域
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scrollHeight = this.$refs.orderlist.clientHeight; // 滚动条的总高度
      let offsetHeight = this.$refs.orderlist.offsetHeight;
      console.log(this.$refs.orderlist.offsetHeight, "this.$refs.orderlist");
      console.log(scrollTop, "scrollTop");
      console.log(scrollHeight, "scrollHeight");

      if (offsetHeight + scrollHeight - scrollTop >= 800) {
        // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
        // 滚动条到底部的条件
        //alert(3)

        this.isLoading = false;
        if (this.hasMore && !this.isLoading) {
          this.isLoading = true;
          // 请求后台数据
          // 请求成功调用 getMoreCallback 方法
          let response = await this.getOrderList(this.currentPage);
          this.getMoreCallback(response);
        }
      }
    },
    getOrderList(currentPage, pageSize) {
      return new Promise(async (resolve, reject) => {
        let url = this.API.order.orderList;
        let OpenId = await this.$utils.CheckOpenIdExist(this);
        let params = {
          openId: OpenId || this.$store.state.userId,
          merchantId: this.$store.state.storeId,
          status: "",
          page: currentPage,
          tbSource: this.currentTab == "history" ? "history" : "",
          size: 500
        };
        this.$http
          .post(url, this.$qs.stringify(params))
          .then(res => {
            if (res.data.result) {
              var orders = res.data.returnData.list;
              for (var i = 0; i < orders.length; i++) {
                var status = orders[i].status;
                // if (status == 0) {
                var create_time = orders[i].createTime;
                var str = create_time.replace(/\-/g, "/");
                //计算剩余时间差值
                var leftTime =
                  new Date(str).getTime() +
                  (orders[i].type == "0" ? 30 : 15) * 60 * 1000;

                if (leftTime > 0) {
                  orders[i].leasttime = leftTime;
                } else {
                  //移除超时未支付的订单
                  orders[i].status = 4;
                  orders.splice(i, 1);
                }

                // }
              }
              // resolve(orders);
              this.orderList = orders;
              this.orderCount = this.orderList.length;
              setTimeout(() => {
                this.loading = false;
              }, 1000);
            } else {
              this.loading = false;
              reject(res.data.message);
            }
          })
          .catch(err => {
            this.loading = false;
            reject(false);
          });
      });
    },
    showOrderDetail(id, type) {
      this.$router.push({
        path: "/account/order-detail",
        query: {
          id: id,
          tab: type
        }
      });
    },
    close() {
      this.showPay = false;
    },
    getOrderId(id) {
      let url = this.API.order.getOrderId;
      let params = {
        outTradeNo: id,
        merchantId: this.$store.state.storeId
      };
      this.$http
        .get(url + "?" + this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            console.log(res);
            id = res.data.returnData;
            this.getOrderDetail(id);
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
    getOrderDetail(id) {
      let url = this.API.order.orderDetail;
      let params = {
        orderId: id
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.paidOrderInfo = res.data.returnData;
            console.log(this.paidOrderInfo);
            this.gaPurchase();
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },

    //GA purchase埋点
    gaPurchase() {
      this.$gaAction.purchase(
        this.paidOrderInfo.skus,
        this.paidOrderInfo.orderNo,
        this.paidOrderInfo.payAmount,
        this.paidOrderInfo.orderFare
      );
    }
  }
};
</script>
<style scoped lang='less'>
/* @import url(); 引入css类 */

.my-container .nav-content {
  border: none;
}
.order-container {
  // border: 0.1rem solid #eaeaea;
  // padding-bottom: 6rem;
  // border-bottom: none;
  position: relative;
  .order-top {
    display: flex;
    border-bottom: 0.1rem solid #eaeaea;
    .order-title {
      padding: 1.6rem 2rem;
      cursor: pointer;
      &.select-tab {
        color: #333333;
      }
      &.detail-title {
        border: 0.1rem solid #eaeaea;
        border-bottom: none;
        cursor: pointer;
      }
    }
  }
  &.detail-box {
    border: none;
  }
  .title {
    width: 100%;
    padding: 1.6rem 2rem;
    border-bottom: 0.1rem solid #eaeaea;
    font-size: 1.2rem;
    line-height: 1.67;
  }
  .no-data {
    padding: 1.6rem 2rem;
  }
  .tips {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 1.2rem 0;
    border-bottom: 0.1rem solid #eaeaea;
    .tip-info {
      width: 1.2rem;
      height: 1.2rem;
      margin-right: 0.5rem;
      margin-top: 0.1rem;
    }

    .close {
      position: absolute;
      right: 1rem;
      // width: 30px;
      // height: 30px;
      padding: 1rem;
      top: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .tip-close {
      width: 0.9rem;
      height: 0.9rem;
      cursor: pointer;
    }
  }
  .order-list {
    display: flex;
    flex-wrap: wrap;

    .order-box {
      display: flex;
      // justify-content: space-between;
      width: 100%;
      padding: 3rem 2rem;
      border-top: 0.1rem solid #eaeaea;
      &:first-child {
        border-top: none;
      }

      .order-item {
        width: 25%;
        display: flex;
        .herf_tilte {
          cursor: pointer;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .order-container {
    // padding-bottom: 6rem;
  }
}
@media screen and (max-width: 768px) {
  /deep/.my-container .nav-content {
    margin: 0;
    border: none;
  }
  .order-container {
    border: none;
    padding-bottom: 2rem;
    .order-top {
      border-top: 0.1rem solid #eaeaea;
    }
    .tips {
      padding: 1.2rem 2rem;
      justify-content: flex-start;
      align-items: center;
      .tip-info {
        margin-right: 0.9rem;
      }
      .close {
        top: initial;
      }
      .tip-text {
        width: 22rem;
      }
    }
    .order-title {
      // display: none;
    }

    .order-list {
      // border-top: 0.1rem solid #eaeaea;
      .order-box {
        justify-content: space-between;
        .order-item {
          &.order-status {
            width: 20%;
          }
          &.order-no {
            width: 45%;
          }
          &.order-action {
            width: 17%;
            text-align: right;
          }
        }
      }
    }

    .actions {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderList.vue